import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

/** queryKey: ['loan-demand', moneypoolId, demandId] — carries `events` */
export const getLoanDemand = async (ctx: QueryFunctionContext) => {
    const { data }: { data: ILoanDemandDetail } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/loan-demands/${ctx.queryKey[2]}/`
    )
    return data
}

/**
 * A message on the request. `audience: 'managers'` is «یادداشت برای مدیران»:
 * the requester never receives it and nobody is texted. Left out, it is a
 * message to the member, which is all this endpoint did before — so only send
 * it when the server has said it understands it (`viewer.can_note`).
 */
export const postLoanDemandComment = async (payload: {
    moneypoolId: string | number
    demandId: string | number
    note: string
    audience?: TLoanDemandAudience
}) => {
    const { data }: { data: ILoanDemandEvent } = await request.post(
        `/api/v1/moneypools/${payload.moneypoolId}/loan-demands/${payload.demandId}/comments/`,
        payload.audience
            ? { note: payload.note, audience: payload.audience }
            : { note: payload.note }
    )
    return data
}

/**
 * «موافقم». Final: the backend refuses a second call with a 400 whose `detail`
 * is the Persian sentence to show — it was a toggle until 2026-09-11, and a
 * manager could quietly withdraw their agreement.
 *
 * POST rather than the GET Android sends: the backend accepts both, and a GET
 * that mutates is not something to spread to a new client.
 */
export const agreeToLoanDemand = async (payload: {
    moneypoolId: string | number
    demandId: string | number
}) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneypoolId}/loan-demands/${payload.demandId}/like/`
    )
    return data
}

/**
 * «مخالفم», with its reason. Managers-only: the requester never sees it and
 * nobody is texted — which is why it is not a comment.
 */
export const objectToLoanDemand = async (payload: {
    moneypoolId: string | number
    demandId: string | number
    note: string
}) => {
    const { data }: { data: ILoanDemandEvent } = await request.post(
        `/api/v1/moneypools/${payload.moneypoolId}/loan-demands/${payload.demandId}/objection/`,
        { note: payload.note }
    )
    return data
}

/** The backend's own sentence for a refused vote, when it sent one. */
export const refusalMessage = (error: unknown): string | undefined => {
    const detail = (error as { response?: { data?: { detail?: unknown } } })
        ?.response?.data?.detail
    return typeof detail === 'string' && detail.trim() ? detail : undefined
}
